import { Field, FieldLabel } from '@global/FormInput/Field/Field.styled'
import styled, { css } from 'styled-components'
import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { textSM } from '@styles/fonts'

export const RadioGroup = styled(Field)``

export const RadioGroupLabel = styled(FieldLabel)``

export const RadioGroupItems = styled.div`
  display: flex;
  flex-direction: ${({ direction }) =>
    direction == 'column' ? 'column' : 'row'};

  ${({ direction }) =>
    direction == 'column'
      ? css`
          ${Field} {
            margin-bottom: 10px;

            &:last-child {
              margin-bottom: 0px;
            }
          }
        `
      : css`
          ${Field} {
            margin-bottom: 0px;
          }
        `}

  @media ${DEVICES.mobile} {
    flex-direction: ${({ mobileDirection }) =>
      mobileDirection == 'row' ? 'row' : 'column'};

    ${({ mobileDirection }) =>
      mobileDirection == 'row'
        ? css`
            ${Field} {
              margin-bottom: 0px;
            }
          `
        : css`
            ${Field} {
              margin-bottom: 12px;

              &:last-child {
                margin-bottom: 0px;
              }
            }
          `}
  }
`

export const Error = styled.div`
  ${textSM};
  color: ${COLORS.error};
  display: flex;
  align-items: center;
`
